module.exports = __webpack_public_path__ + "static/media/backgroundImg3.7b6e90a1.jpg";